<template>
  <div class="q_mar_t15px q_pad_lr15px q_mar_b100px">
    <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
      <van-swipe-item v-for="(item, index) in bannerList" :key="index">
        <van-image width="100%" fit="cover" :src="item"/>
      </van-swipe-item>
    </van-swipe>
    <div class="q_text_l q_bold q_mar_b15px q_bor_bottom q_pad_tb15px">{{ donation.ittle }}</div>
    <div class="q_text_s q_color_gray">募捐人数：{{ donation.numberUser }}人<span v-if="donation.ratio!==0"
                                                                                 class="q_flo_right">捐款{{
        donation.threshold
      }}元以上，获得积分：{{
        donation.ratio
      }}%</span>
    </div>
    <div :class="donation.state=='0'?'q_pad_15px q_po_re q_mar_t15px':'q_pad_15px q_po_re q_mar_t15px q_gray'">
      <img src="../../assets/image/line_bj.png"
           style="width: 100%;position: absolute;top: 0;left: 0;z-index: -1;"/>
      <div class="q_speed q_inlineblock q_veralign_middle" style="width: 100%;">
				<span class="q_text_s" style="color: rgba(255,255,255,.8);">已募捐<span
            class="q_color_white q_mar_lr5px">{{ donation.money }}</span>元，约{{ percentage }}%</span>
        <span class="q_text_s q_flo_right" style="color: rgba(255,255,255,.8);">{{ donation.sumMoney }}元</span>
        <div class="q_speed_b q_mar_t5px">
          <div :style="{width: percentage + '%'}" class="q_speed_t"></div>
        </div>
      </div>
    </div>
    <div style="height: 2vw;background-color: #F2F3F7;margin-left: -4vw;width: 100vw;" class="q_mar_t15px"></div>
    <van-tabs swipe-threshold="4">
      <van-tab title="募捐详情" name="1">
        <div class="q_artdea">
          <div class="q_artdea">
            <p v-html="donation.details"></p>

          </div>
        </div>
      </van-tab>
      <van-tab title="爱心人士" name="2">
        <van-pull-refresh v-model="refreshing" @refresh="onRefresh" success-text="刷新成功" v-if="!showEmpty">
          <van-list
              v-model:loading="loading"
              :finished="finished"
              :immediate-check="false"
              finished-text="没有更多了"
              @load="onLoad"
              error-text="请求失败，点击重新加载"
          >

            <div class="q_mar_t10px q_vertical_left" v-for="item in list">
              <van-image fit="cover" :src="item.avatar"
                         class="q_enter_pic q_flo_left"/>
              <div class="q_flo_left q_mar_l10px" style="width: 48.66vw;">
                <div class="q_moit1">{{ item.userName }}</div>
                <div class="q_text_s q_color_gray q_mar_t5px">{{ item.createTime }}</div>
              </div>
              <span class="q_inlineblock q_bold q_text_m q_color_default q_right"
                    style="width: 30vw;">{{ item.money }}元</span>
            </div>
          </van-list>
        </van-pull-refresh>
        <!--空数据-->
        <div class="q_center" style="margin: 3vh 0;" v-if="showEmpty">
          <img src="@/assets/image/none.png" style="width: 26vw;"/>
          <p class="q_color_gray q_text_s q_mar_t20px">暂无信息</p>
        </div>

      </van-tab>
      <van-tab title="中队信息" name="3">
        <div class="q_vertical_left q_mar_b15px q_join" @click="goToJoindea()">
          <div class="q_inlineblock">
            <van-image class="q_join_img" fit="cover" :src="dept.pic"/>
          </div>
          <div class="q_mar_l15px q_inlineblock q_con">
            <div class="q_text_m q_bold q_moit2 q_justify">{{ dept.deptName }}</div>
            <div class="q_text_s q_color_gray q_mar_t5px q_moit2">{{ dept.address }}</div>
            <div class="q_vertical_left q_mar_t30px q_borra" v-if="dept.userList!=null&&donation.deptId != 100">
              <span v-if="dept.userList[0]!=undefined">
                 <van-image width="5vw" height="5vw" fit="cover"
                            :src="dept.userList[0].avatar" style="margin-right: 1vw;"/>
              </span>
              <span v-if="dept.userList[1]!=undefined">
                <van-image width="5vw" height="5vw" fit="cover"
                           :src="dept.userList[1].avatar" style="margin-right: 1vw;"/>
              </span>
              <span v-if="dept.userList[2]!=undefined">
                <van-image width="5vw" height="5vw" fit="cover"
                           :src="dept.userList[2].avatar" style="margin-right: 1vw;"/>
              </span>

              <span class="q_text_s q_color_gray">等{{ dept.userList.length }}位伙伴</span>
            </div>
          </div>
          <van-button plain type="primary" size="small" color="#FF5733">查看详情</van-button>
        </div>
      </van-tab>
    </van-tabs>
    <van-goods-action>
      <van-goods-action-button v-if="donation.state=='0'" type="danger" color="#FF5733" text="献出爱心"
                               @click="show = true"/>
      <div v-if="donation.state=='1'" class="q_center q_bold q_color_gray q_text_l" style="width: 100%;">募捐已停止
      </div>
      <div v-if="donation.state=='2'" class="q_center q_bold q_color_gray q_text_l" style="width: 100%;">募捐已结束
      </div>
    </van-goods-action>
    <van-action-sheet v-model="show" title="爱心捐赠">
      <div class="content">
        <div v-for="(item,index) in domains" :key="index" :class="{q_sped:index==current}" class="q_spe"
             @click="check(item.value,index)">{{ item.value }}元
        </div>
        <div class="q_mar_tb5px">
          <input type="number" @focus="moneyFocus" v-model="userDonationForm.money"
                 placeholder="请输入金额  自由捐赠,爱心无价"
                 class="q_spe_inp"/>
        </div>
        <div class="q_center q_mar_t30px">
          <van-button class="q_btn_min" round color="#FF5733" loading-type="spinner" @click="affirmDonation"
                      loading-text="正在提交">确 认
          </van-button>
        </div>
      </div>
    </van-action-sheet>
  </div>
</template>

<script>
import {getDonation} from "@/api/donation";
import {getJoinById} from "@/api/join";
import {listUserDonation} from "@/api/userDonation";
import {abcPay} from "@/api/pay";
import {wxCloseShare} from "@/utils/jiutang";

export default {
  name: 'Speeddea',
  props: {
    msg: String
  },
  data() {
    return {
      showEmpty: false,
      refreshing: false,
      loading: false,
      finished: false,
      list: [],
      pageParam: {
        pageNum: 0,
        pageSize: 5,
        donationId: ""
      },
      show: false,
      donationId: '',
      //轮播图
      bannerList: [],
      donation: {},
      userDonationForm: {},
      dept: {},
      domains: [],
      current: '',
      //百分比
      percentage: ''
    }
  },
  created() {
    // wxCloseShare()
    this.donationId = this.$route.query.id;
    this.init()
  },
  methods: {
    /**
     * 下拉刷新
     */
    onRefresh() {
      this.pageParam.pageNum = 0
      this.pageParam.pageSize = 5
      this.pageParam.donationId = this.donation.id
      this.list = []
      // 清空列表数据
      this.finished = false
      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true
      this.onLoad()
    },
    /**
     * 下滑加载更多
     */
    onLoad() {
      this.pageParam.pageNum++
      if (this.pageParam.pageNum == 1) {
        this.$modal.loading()
      }
      //查询爱心人士信息列表
      listUserDonation(this.pageParam).then(res => {
        if (res.total == 0) {
          this.showEmpty = true
        } else {
          this.showEmpty = false
        }
        //是否下拉刷新
        if (this.refreshing) {
          this.list = [];
          this.refreshing = false;
        }
        for (let i = 0; i < res.rows.length; i++) {
          this.list.push(res.rows[i]);
        }
        // 加载状态结束
        this.loading = false;

        // 数据全部加载完成
        if (this.list.length >= res.total) {
          this.finished = true;
        }
      }).finally(() => {
        this.$modal.closeLoading()
      })
    },
    /**
     * 初始化
     */
    init() {
      //获取捐款详细信息
      getDonation(this.donationId).then((res) => {
        this.donation = res.data
        this.bannerList = res.data.banner.split(',');
        this.domains = (new Function("return " + res.data.setMoney))();
        //this.userDonationForm.money = this.domains[0].value
        this.percentage = ((res.data.money / res.data.sumMoney) * 100).toFixed(2)
      }).then(() => {
        //查询中队信息
        getJoinById(this.donation.deptId).then((res) => {
          this.dept = res.data
        })
      }).then(() => {
        this.onRefresh()
      })
    },
    goToJoindea() {
      this.$router.push({
        path: '/home/Joindea', query: {id: this.donation.deptId}
      });
    },
    //选中金额
    check(money, index) {
      this.userDonationForm.money = money
      this.current = index;
    },
    //获得焦点触发
    moneyFocus() {
      this.current = 99999;
    },
    //确认捐款
    affirmDonation() {
      if (this.userDonationForm.money == '' || this.userDonationForm.money == undefined) {
        return this.$modal.alert("请输入捐款金额");
      }
      if (this.userDonationForm.money <= 0) {
        return this.$modal.alert("捐款金额不能小于0元");
      }
      if (this.userDonationForm.money > 999999) {
        return this.$modal.alert("单次捐款金额不能大于999999元");
      }
      var pattern = new RegExp("^(([1-9]{1}\\d*)|(0{1}))(\\.\\d{1,2})?$");
      if (!pattern.test(this.userDonationForm.money)) {
        return this.$modal.alert("金额最多两位小数");
      }

      this.userDonationForm.donationId = this.donation.id
      this.$modal.loading('正在支付...')
      abcPay('1', this.userDonationForm.donationId, this.userDonationForm.money).then((res) => {
        if (res.code == 200) {
          this.$modal.closeLoading()
          window.location.href = res.payUrl
        }
      })
    }
  },
}
</script>
<style scoped="scoped">
>>> .van-swipe {
  font-size: 0;
  border-radius: 5px;
}

.van-swipe .van-image {
  height: 194px;
}

.van-goods-action-button--last {
  margin-right: 80px;
}

.van-goods-action-button--first {
  margin-left: 80px;
}

.van-goods-action {
  box-shadow: 0 0 10px #f2f3f7;
  height: 60px;
}

.van-popup {
  border-radius: 6px;
}


.q_speed_b {
  background-color: #F2F3F7;
  width: 100%;
  height: 6px;
  border-radius: 3px;
  position: relative;
}

.q_speed_t {
  background-color: #FF5733;
  width: 10%;
  height: 6px;
  border-radius: 3px;
  position: absolute;
  top: 0px;
  left: 0;
}

>>> .van-tab--active {
  font-weight: 700;
  font-size: 16px;
}

>>> .van-tabs__line {
  background-color: #FF5733;
  height: 6px;
  border-radius: 3px;
  width: 30px;
}

>>> .van-tabs__wrap {
  margin: 10px 0 20px 0;
}

.q_enter_pic {
  width: 40px;
  height: 40px;
  border-radius: 20px;
}

.q_enter_pic >>> .van-image__img {
  border-radius: 20px;
}

.q_join_img {
  width: 105px;
  height: 105px;
}

.q_join_img >>> .van-image__img {
  border-radius: 5px;
}

.q_borra >>> .van-image__img {
  border-radius: 50%;
}

.q_con {
  width: 165px;
}

.q_join .van-button {
  border-bottom-left-radius: 16px;
  border-bottom-right-radius: 16px;
  border-top-right-radius: 16px;
  width: 70px;
}

.content {
  padding: 16px;
}

.van-popup {
  border-radius: 6px 6px 0 0;
}

.q_spe {
  min-width: 75px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  border-radius: 5px;
  background-color: #F2F3F7;
  font-size: 14px;
  margin-right: 10px;
  display: inline-block;
  margin-bottom: 10px;
}

.q_sped {
  color: #ffffff;
  background-color: #FF5733;
}

.q_spe_inp {
  height: 40px;
  line-height: 40px;
  border: none;
  outline: none;
  font-size: 14px;
  font-weight: 700;
  box-shadow: 0 0 5px #f2f3f7;
  width: 100%;
  border-radius: 20px;
  padding: 0 15px;
}
</style>
